import { usePostVendorApi, usePutVendorApi } from 'api/vendor'
import { Flex } from 'components/shared/flex'
import { DateField, InputField, SelectField } from 'components/shared/input'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useContext, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Form, useEffectSkipFirst, useForm } from 'utils/hooks'
import { ApiError } from 'utils/network/api_hooks'
import { Vendor, VendorForm, VENDOR_TYPE_SELECT_ITEMS } from 'entities/vendor'
import { AddressFormView } from 'components/address/address_form'

const FormView = (form: Form<VendorForm>, apiError: ApiError) => {
    return (
        <>
            <Flex>
                <InputField form={form} attr="name" apiError={apiError} label="業者名称" />
            </Flex>
            <Flex>
                <DateField form={form} attr="contractDate" apiError={apiError} label="契約日" required />
                <SelectField form={form} attr="type" apiError={apiError} label="タイプ" selectItems={VENDOR_TYPE_SELECT_ITEMS} includeBlank required />
            </Flex>
            <InputField form={form} attr="tel" apiError={apiError} label="電話番号(ハイフンあり)" placeholder="xx-xxxx-xxxx" />
            <AddressFormView form={form} apiError={apiError} />
        </>
    )
}

type NewVendorFormProps = {
    onComplete?: () => void
}

export const NewVendorForm = (props: NewVendorFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePostVendorApi()
    const form = useForm<VendorForm>({ address: {} })
    const [show, setShow] = useState<boolean>(false)

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                setShow(false)
                props.onComplete()
            }
        }
    }, [api.loading])

    const handleClose = () => {
        setShow(false)
    }

    return (
        <>
            <Button
                variant="success"
                onClick={() => {
                    setShow(true)
                }}
            >
                新規登録
            </Button>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Vendorの登録</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>{FormView(form, api.apiError)}</>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        閉じる
                    </Button>
                    <Button variant="success" onClick={handleUpdate}>
                        登録
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
type EditVendorFormProps = {
    vendor: Vendor
    show: boolean
    onClose: () => void
    onComplete?: () => void
}

export const EditVendorForm = (props: EditVendorFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePutVendorApi()
    const form = useForm<VendorForm>(props.vendor)

    useEffectSkipFirst(() => {
        form.set(props.vendor)
    }, [props.vendor])

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                props.onComplete()
            }
        }
    }, [api.loading])

    return (
        <Modal show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Vendorの編集</Modal.Title>
            </Modal.Header>
            <Modal.Body>{form.object.id && FormView(form, api.apiError)}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onClose}>
                    閉じる
                </Button>
                <Button variant="success" onClick={handleUpdate}>
                    更新
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
